/* tslint:disable */
/* eslint-disable */
/**
 * CrateHackers API
 * This is the thing that does data stuff.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the MoveCrateFolderDto interface.
 */
export function instanceOfMoveCrateFolderDto(value) {
    if (!('crateIds' in value) || value['crateIds'] === undefined)
        return false;
    if (!('folderId' in value) || value['folderId'] === undefined)
        return false;
    if (!('index' in value) || value['index'] === undefined)
        return false;
    return true;
}
export function MoveCrateFolderDtoFromJSON(json) {
    return MoveCrateFolderDtoFromJSONTyped(json, false);
}
export function MoveCrateFolderDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'crateIds': json['crateIds'],
        'folderId': json['folderId'],
        'index': json['index'],
    };
}
export function MoveCrateFolderDtoToJSON(json) {
    return MoveCrateFolderDtoToJSONTyped(json, false);
}
export function MoveCrateFolderDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'crateIds': value['crateIds'],
        'folderId': value['folderId'],
        'index': value['index'],
    };
}
